"use client";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import cn from "classnames";
import ActiveAnchor from "@/components/common/ActiveAnchor";
import List from "@/components/common/List";
import { isPageNavItem } from "@/components/navigation/utils";
import { type Noop } from "@/types";
import { type MultiLevelNavBarItem } from "../../../types";
import { useNavItemState } from "../hooks/useNavItemState";
import s from "./MobileNavItem.module.scss";

interface Level1ItemProps {
  item: MultiLevelNavBarItem;
  level?: number;
  isOpen?: boolean;
  onToggle?: Noop;
}

export default function MobileNavItem(props: Level1ItemProps) {
  const { item, level = 0, isOpen, onToggle } = props;
  const { open, handleToggle } = useNavItemState({
    item,
    level,
    isOpen,
    onToggle,
  });
  const isTopLevel = level === 0;

  if (isPageNavItem(item)) {
    return (
      <ActiveAnchor
        href={item.url}
        openInNewTab={item.openInNewTab}
        className={cn({
          [s.anchor]: level === 0,
          [s.subAnchor]: level === 1,
          [s.nestedAnchor]: level === 2,
        })}
      >
        {item.label}
      </ActiveAnchor>
    );
  }

  return (
    <div className={isTopLevel ? s.anchor : s.subAnchor}>
      <span onClick={handleToggle} className={s.groupLabel}>
        {item.label}
        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
      </span>

      {open && (
        <div className={isTopLevel ? s.menu : s.subMenu}>
          <List
            items={item.subMenuItems}
            renderItem={(subItem) => (
              <MobileNavItem item={subItem} level={level + 1} />
            )}
            variant="vertical"
          />
        </div>
      )}
    </div>
  );
}
